<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store.dispatch("patients/getDetails", this.itemId);
        },
  computed: {
    patient() {
          return this.$store.state.patients.patient;
      }
  },
};
</script>